export { authService } from './authService';
export { createSupabaseService, userService, bikeService, evStationService } from './dataService';
export type { User, Bike, EVStation } from './dataService';

// Export role service
export { roleService } from './roleService';
export { userRoleService } from './userRoleService';

// Export all database services
export {
  userService as dbUserService,
  stationService,
  stationPriceService,
  deviceService,
  commandService,
  lastStatusDeviceService,
  lastRevenueService,
  lastStatusStationService,
  blogService,
  bannerService,
  metricService,
  metricStationService,
  paymentService,
  userFavoriteStationService,
  devicePriceLogService,
  stationRequestService,
  contactOwnerService,
  gatewayStationService,
  gatewayDeviceService,
  websiteContentService,
  navigationService,
  configPlatformService,
} from './databaseService';

// Export dashboard service
export { dashboardService } from './dashboardService';
export type {
  DeviceOverview,
  UserStatistics,
  MonthlyRevenueItem,
  EnergyConsumption,
  UserRegistrationChartData,
  EnergyConsumptionCategory,
  RevenueBarChartData,
  StationRevenueRanking,
  DashboardSummary,
} from '@/types/dashboard';
